import PageContent from './components/PageContent'

interface ListProps {
  pageFilters: {
    [key: string]: any,
  },
}

const List = (props: ListProps) => {
  const { pageFilters } = props

  return (
    // @ts-expect-error TS2741
    <PageContent pageFilters={pageFilters} />
  )
}

export default List
